import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { ServiceKind } from "@bitory-gmbh/bsm";

export interface Fulfillment {
  id: UUID;
  companyId: UUID;
  branchId: UUID;
  relationshipId: UUID;
  commitmentId: UUID;
  processId: UUID;
  serviceKind: ServiceKind;
  documentId: UUID | null;
  documentKind: string | null;
  plannedDate: RFC3339timestamp;
  state: FulfillmentState;
  createdAt: RFC3339timestamp;
  updatedAt: RFC3339timestamp;
}

export enum FulfillmentState {
  Zero = "",
  Planning = "planning",
  Execution = "execution",
  Executed = "executed",
  PartiallyExecuted = "partially_executed",
  Completed = "completed",
  Cancelled = "cancelled",
}

export const FulfillmentStateList = Object.values(FulfillmentState);

export function parseFulfillmentState(
  str: string,
): FulfillmentState | undefined {
  switch (str.toLowerCase()) {
    case "planning":
      return FulfillmentState.Planning;
    case "execution":
      return FulfillmentState.Execution;
    case "executed":
      return FulfillmentState.Executed;
    case "partially_executed":
      return FulfillmentState.PartiallyExecuted;
    case "completed":
      return FulfillmentState.Completed;
    case "cancelled":
      return FulfillmentState.Cancelled;
    default:
      return FulfillmentState.Zero;
  }
}
